import { useSelector } from "react-redux"

import { useBusinessAccountId } from "./useBusinessAccountId"

/**
 * Selected billing descriptor, but only while it provably belongs to the
 * business account currently on screen.
 *
 * Switching a business account changes `business_account_id` synchronously,
 * while `descriptor` is only refreshed once the async `monitoringInit` saga
 * resolves. Effects of the render in between would otherwise fire with the new
 * account and the previous account's descriptor — which the backend rejects
 * with 400 "No descriptor '...' on this business account".
 */
// An admin reads the id from the URL (a string or null), a merchant from the
// profile (undefined until it hydrates) — normalize both before comparing.
const normalizeId = (id) => (id === null || id === undefined || id === "" ? null : String(id))

export const useVampDescriptor = () => {
  const business_account_id = useBusinessAccountId()
  const { descriptor, descriptorsBusinessAccount } = useSelector((state) => state.health)

  const belongsToCurrentAccount =
    normalizeId(descriptorsBusinessAccount) === normalizeId(business_account_id)

  return belongsToCurrentAccount ? descriptor : null
}
